import { render, staticRenderFns } from "./FormPage.vue?vue&type=template&id=64647c8c&scoped=true"
import script from "./FormPage.vue?vue&type=script&lang=js"
export * from "./FormPage.vue?vue&type=script&lang=js"
import style0 from "./FormPage.vue?vue&type=style&index=0&id=64647c8c&prod&lang=scss"
import style1 from "./FormPage.vue?vue&type=style&index=1&id=64647c8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64647c8c",
  null
  
)

export default component.exports